<div class="mobile-bar" role="region" aria-label="Szybki kontakt">
  <div class="row">
    <a href="tel:+&#52;&#56; &#54;&#48;&#50; &#55;&#53;&#57; &#52;&#53;&#51;" class="mp-btn tw-discreet tw-border tw-full-width mobile-bar-button-call">
      <i class="fa-sharp fa-regular fa-phone"></i>
      Zadzwoń
    </a>
    <app-cta-button [text]="'Wycena'" [fullWidth]="true" [additionalButtonClass]="'mobile-bar-button-quote'"></app-cta-button>
  </div>
</div>
